import type { IDPHint } from './constants';

const LOCAL_STORAGE_KEY_IDP_HINT = 'kc-idp-hint';

export function saveIdpHintToLocalStorage(hint: IDPHint): void {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY_IDP_HINT, hint);
  } catch (error) {
    console.error('Error saving IDP hint to local storage', error);
  }
}

export function getIdpHintFromLocalStorage(): IDPHint | undefined {
  try {
    const hint = localStorage.getItem(LOCAL_STORAGE_KEY_IDP_HINT);
    return hint ? (hint as IDPHint) : undefined;
  } catch (error) {
    console.error('Error getting IDP hint from local storage', error);
    return undefined;
  }
}

export function clearIdpHintFromLocalStorage(): void {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY_IDP_HINT);
  } catch (error) {
    console.error('Error clearing IDP hint from local storage', error);
  }
}
